
import MagstimTableData from './MagstimTableData';
import { CurrentLang } from 'common';
import * as StringUtils from 'common/utils/StringUtils.js'

class MagstimTableDatarMT extends MagstimTableData {

    getNamedValuePairs(data) {

        let tableData = [];
        //console.log("details getNamedValuePairs", this.props.data);

        tableData = [
            { name: CurrentLang().run_treatment_plan_controls_latest_mt_level, value: data.CurrentRMTLevel ===  CurrentLang().no_data ? data.CurrentRMTLevel : `${data.CurrentRMTLevel}%` },
            { name: CurrentLang().patient_home_last_mt, value: StringUtils.formatUtcDateOrNoData(data.LastRMTDetermination, CurrentLang().no_data) },
        ]
        return tableData;
    }
}

export default MagstimTableDatarMT;
